import { Model as r } from "../../../model.js";
class h extends r {
  constructor(o) {
    super(), this.refId = o.refId, this.duration = o.duration, this.terms = o.terms, this.font = o.font, this.textColor = o.textColor, this.highlightTextColor = o.highlightTextColor, this.backgroundColor = o.backgroundColor, this.buttonColor = o.buttonColor, this.spentButtonColor = o.spentButtonColor, this.textButtonColor = o.textButtonColor, this.name = o.name, this.image = o.image, this.logo = o.logo, this.title = o.title, this.redeemMethod = o.redeemMethod, this.externalPromotionId = o.externalPromotionId, this.externalSuccessPromotionId = o.externalSuccessPromotionId, this.startDatetime = o.startDatetime, this.isUnlimited = o.isUnlimited, this.maximumUses = o.maximumUses, this.usageRules = o.usageRules, this.requiresVerifiedPhone = o.requiresVerifiedPhone;
  }
  getRulesByType(o) {
    return this.usageRules.filter((e) => e.ruleType === o);
  }
}
export {
  h as VoucherSettingsModel
};
//# sourceMappingURL=voucherSettings.model.js.map
